// extracted by mini-css-extract-plugin
module.exports = {"root":"Text_root__1Ipb5","regular":"Text_regular__u0L7P","semiBold":"Text_semiBold__rzPDE","caption":"Text_caption__1Hjpz"};